import { Directive, ElementRef, ViewChildren, QueryList, Input, SimpleChanges, Renderer2 } from '@angular/core';
import { MatOption } from '@angular/material/core';

@Directive({
  selector: '[selectAutoSizer]'
})
export class SelectAutoSizerDirective {

  private _options: QueryList<ElementRef>
  @Input('options') set options(options: QueryList<ElementRef>) {
    this._options = options;      
    if(options) this.manageSize()
  }

  constructor(    private renderer: Renderer2    ){}

  manageSize()
  {
    let max = -1    
    this._options.forEach( option => {            
      let value = option.nativeElement.fontSize
      
      if ( value > max ) max = value
    })      
    //this._options.forEach( label => this.updateWidth(label, max) )  
  }

  updateWidth(el: ElementRef, width: number)
  {
    //this.renderer.setStyle(el.nativeElement, 'width'  , `${width}px`);
    //this.renderer.setStyle(el.nativeElement, 'display', `block`);    
  }

}

